import React from 'react'

// Cache the official JSX factories once, shared by the compiled UI modules.
export const element = React.createElement
export const fragment = React.Fragment
